<icc-list [searchable]="true" [items]="colors"
          [itemTemplate]="'itemColor'"
          [selected]="selectedId"
          (select)="select($event)"></icc-list>
